import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { closeModal } from '../../../../store/actions/modal';
import { setLoggedInStatus } from '../../../../store/actions/global';

class Top extends Component {
	state = {
		email: '',
		password: '',
		hidden: true,
		remember: false,
		validate: {
			email: true,
			password: true,
		},
		error: null,
		waiting: false,
	}

	reloadPageOnSuccess = true;

	componentDidMount() {
		document.addEventListener('keydown', this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onKeyDown);
	}

	onKeyDown = (event) => {
		if (event.keyCode === 13) {
			this.onSubmit(event);
		}
	}

	onChange = (event, type) => {
		const valid = this.onValidate(event.target.value, type);
		const { validate } = this.state;

		this.setState({
			[type]: event.target.value,
			validate: {
				...validate,
				[type]: valid,
			},
		});
	}

	onClick = (event) => {
		const { remember } = this.state;
		event.preventDefault();
		this.setState({ remember: !remember });
	}

	onSubmit = (event) => {
		const { email, password, remember } = this.state;
		const validEmail = this.onValidate(email, 'email');
		const validPass = this.onValidate(password, 'password');

		event.preventDefault();
		this.setState({ validate: { email: validEmail, password: validPass }, error: null });
		if (!validEmail || !validPass) return;

		/* PAYLOAD SENT TO LOGIN ENDPOINT
			{
				emailAddress: <String>,
				password: <String>,
				rememberMe: <Boolean>
			}
		*/
		this.onResponse(this.onRequest({
			emailAddress: email,
			rememberMe: remember,
			password,
		}));
	}

	onResponse = (response) => {
		this.setState({ waiting: true });

		// Based on what kind of response is received this is where we add
		// either success or fail functionality
		response
			.then((data) => {
				this.setState({ waiting: false });

				const { success, message } = data;
				const { dispatch } = this.props;
				if (success) {
					dispatch(closeModal());
					if (this.reloadPageOnSuccess) {
						window.location.reload();
					} else {
						dispatch(setLoggedInStatus(true));
					}
				} else {
					this.setState({
						error: message,
					});
				}
			})
			.catch((error) => {
				this.setState({
					waiting: false,
					error,
				});
			});
	}

	async onRequest(payload) {
		try {
			const response = await this.postPayload(payload);
			return response;
		} catch (error) {
			return error;
		}
	}

	postPayload = (payload) => {
		const { data } = this.props;
		const { endpoint } = data;

		return fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		}).then((response) => {
			return response.json();
		});
	}

	onShow = (event) => {
		const { hidden } = this.state;
		event.preventDefault();
		this.setState({ hidden: !hidden });
	}

	onValidate = (value, rule) => {
		let isValid = true;

		if (rule === 'email') {
			const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
			isValid = pattern.test(value) && isValid;
		}

		if (rule === 'password') {
			isValid = value.length >= 6 && isValid;
		}

		return isValid;
	}

	onEmployeCredsSubmit = (event) => {

	}

	render() {
		const {
			email,
			password,
			remember,
			hidden,
			validate,
			error,
			waiting,
		} = this.state;
		const { callbacks, data } = this.props;
		const {
			emailLabel,
			forgotLabel,
			formTitle,
			loginButtonLabel,
			passwordLabel,
			showPasswordLabel,
			rememberLabel,
			invalidEmailText,
			invalidPasswordText,
			employeeCredentialsLabel,
			employeeCredentialsLink,
			employeeCredentialsUrl,
		} = data;
		const active = remember ? 'u-active' : null;
		const passwordType = hidden ? 'password' : 'text';
		const emailValid = !validate.email ? 'u-show' : null;
		const passValid = !validate.password ? 'u-show' : null;
		const showError = error ? 'u-show' : null;

		let submitButton = (
			<a href="/" className="btn btn--primary btn--inverted G1-login__button" onClick={this.onSubmit}>
				{loginButtonLabel}
			</a>
		);

		if (waiting) {
			submitButton = (
				<a href="/" className="btn btn--primary btn--inverted G1-login__button" onClick={(event) => { event.preventDefault(); }}>
					<div className="loading">
						<div className="loading__dots">Loading...</div>
					</div>
				</a>
			);
		}

		return (
			<div className="G1-login__view">
				<h2 className="G1-login__title">{formTitle}</h2>
				<form className="G1-login__form">
					<div className="G1-login__control">
						<label className="G1-login__label">{emailLabel}</label>
						<div className="G1-login__input-wrapper">
							<input
								className="G1-login__input"
								type="text"
								value={email}
								onChange={(event) => { this.onChange(event, 'email'); }}
							/>
						</div>
						<p className={['G1-login__error', emailValid].join(' ')}>
							<span className="G1-login__error-cross" />
							{invalidEmailText}
						</p>
					</div>
					<div className="G1-login__control">
						<label className="G1-login__label">{passwordLabel}</label>
						<div className="G1-login__input-wrapper">
							<input
								className="G1-login__input u-padding-right"
								type={passwordType}
								value={password}
								onChange={(event) => { this.onChange(event, 'password'); }}
							/>
							<a href="/" className="G1-login__show-password" title={showPasswordLabel} onClick={this.onShow}>
								<span className="G1-login__show-text">{showPasswordLabel}</span>
							</a>
						</div>
						<p className={['G1-login__error', passValid].join(' ')}>
							<span className="G1-login__error-cross" />
							{invalidPasswordText}
						</p>
					</div>
					<div className="G1-login__control">
						<a href="/" className="G1-login__label u-normal-weight" onClick={(event) => { callbacks.click(event, 'forgot-password'); }}>{forgotLabel}</a>
						<div className="G1-login__checkbox-wrapper">
							<a
								href="/"
								className={['G1-login__checkbox', active].join(' ')}
								onClick={this.onClick}
							>
								<span className="G1-login__checkbox-text">{rememberLabel}</span>
							</a>
						</div>
						<p className={['G1-login__error', showError].join(' ')}>
							{error}
						</p>
					</div>
					<div className="G1-login__control-submit">
						{submitButton}
					</div>
				</form>
				<div className="G1-login__employee-credentials">
					{employeeCredentialsLabel}
					<br />
					<form action={employeeCredentialsUrl} method="post">
						<button type="submit" className="G1-login__employee-link">
							{employeeCredentialsLink}
						</button>
					</form>
				</div>
			</div>
		);
	}
}

Top.propTypes = {
	callbacks: PropTypes.shape({}),
	data: PropTypes.shape({}).isRequired,
	dispatch: PropTypes.func.isRequired,
};

Top.defaultProps = {
	callbacks: {},
};

export default connect()(Top);
